import * as React from "react";
import { forwardRef } from "react";
const SvgKds = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M3.46289 17H14.5408",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M16.9163 4.56811C16.7912 4.0519 16.534 3.57709 16.17 3.19023C15.806 2.80337 15.3477 2.51775 14.8401 2.36136C14.3325 2.20498 13.7929 2.18321 13.2744 2.29818C12.7558 2.41315 12.276 2.66092 11.882 3.0172C11.667 2.42602 11.2752 1.91532 10.76 1.55445C10.2447 1.19358 9.63085 1 9.00178 1C8.3727 1 7.75886 1.19358 7.24358 1.55445C6.72831 1.91532 6.33656 2.42602 6.12152 3.0172C5.72755 2.66092 5.24776 2.41315 4.72918 2.29818C4.21061 2.18321 3.67106 2.20498 3.16343 2.36136C2.65581 2.51775 2.19754 2.80337 1.83356 3.19023C1.46958 3.57709 1.2124 4.0519 1.08722 4.56811C0.989415 4.97094 0.973681 5.38934 1.04095 5.79838C1.10822 6.20742 1.25713 6.59875 1.47879 6.94904C1.70045 7.29934 1.99034 7.60144 2.3312 7.83737C2.67205 8.07329 3.0569 8.2382 3.46282 8.32229V12.6919C3.46282 13.0184 3.5925 13.3314 3.82333 13.5623C4.05417 13.7931 4.36725 13.9228 4.6937 13.9228H13.3099C13.6363 13.9228 13.9494 13.7931 14.1802 13.5623C14.4111 13.3314 14.5407 13.0184 14.5407 12.6919V8.32229C14.9467 8.2382 15.3315 8.07329 15.6724 7.83737C16.0132 7.60144 16.3031 7.29934 16.5248 6.94904C16.7464 6.59875 16.8953 6.20742 16.9626 5.79838C17.0299 5.38934 17.0141 4.97094 16.9163 4.56811Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M3.46289 10.8457H14.5408",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgKds);
export default ForwardRef;
